import React from "react";
import "./App.css";
import { BrowserRouter } from "react-router-dom";
import { SnackbarProvider } from "notistack";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { GlobalProvider } from "./components/context/GlobalContext";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";

import AppRouter from "./layout/AppRoutes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/Wallet/Talent/ScrollToTop";
import { 
  PWAUpdateNotification, 
  PWAOfflineIndicator 
} from "./components/PWA";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
    },
  },
});

const App: React.FC = () => {
  return (
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools initialIsOpen={false} />
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <SnackbarProvider>
            <GlobalProvider>
              <BrowserRouter>
                <ScrollToTop />
                <AppRouter />
                
                {/* PWA Components */}
                <PWAUpdateNotification />
                <PWAOfflineIndicator />
              </BrowserRouter>
            </GlobalProvider>
          </SnackbarProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </HelmetProvider>
  );
};

export default App;
